import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpParams } from '@angular/common/http';
import { DomSanitizer, SafeHtml, Title, Meta } from '@angular/platform-browser';
import { BlogPost } from '../Models/BlogPost';
import { AppHttpService } from '../AppServices/app.httpservices';

@Component({
    selector: 'app-blog-detail',
    templateUrl: './blog-detail.component.html',
    styleUrls: ['./blog-detail.component.css'],
    // The post body is injected via [innerHTML] (rich HTML stored in the database).
    // Angular's emulated encapsulation does not add scope attributes to markup that
    // is inserted at runtime, so the component's `.ff-article__content` rules would
    // never reach it and the global theme resets would win. Disabling encapsulation
    // lets the article rules below style the injected HTML; they are namespaced under
    // `.ff-article__content`, so nothing else on the site is affected.
    encapsulation: ViewEncapsulation.None
})
export class BlogDetailComponent implements OnInit {
    post: BlogPost = null;
    safeBody: SafeHtml = null;
    loading = true;
    notFound = false;
    error = '';

    constructor(
        private route: ActivatedRoute,
        private httpClient: AppHttpService,
        private sanitizer: DomSanitizer,
        private titleService: Title,
        private metaService: Meta
    ) { }

    ngOnInit() {
        const slug = this.route.snapshot.paramMap.get('slug');
        const params = new HttpParams().set('slug', slug || '');

        this.httpClient.get<BlogPost>('api/Blog/GetBySlug', params).subscribe(data => {
            this.post = data;
            this.loading = false;

            if (this.post) {
                this.safeBody = this.sanitizer.bypassSecurityTrustHtml(this.post.bodyHtml);
                this.titleService.setTitle(this.post.title + ' | Farkas Floors');
                if (this.post.metaDescription) {
                    this.metaService.updateTag({ name: 'description', content: this.post.metaDescription });
                }
            } else {
                this.notFound = true;
            }
        }, () => {
            this.loading = false;
            this.error = 'Could not load this post right now.';
        });
    }

    goBack(): void {
        window.location.href = '/Blog';
    }
}
